import { object, string, mixed, number, boolean } from "yup";

const validationSchemas = [
  object({
    title: string().required(),
    subtitle: string().required(),
    description: string().required(),
    url: string().required(),
    tags: string(),
    visibility: mixed().oneOf(["public", "private"]),
    bannerData: string()
      .matches(
        /(data:image\/[^;]+;base64[^"]+)/g,
        "Ensure banner image is a valid 'JPEG or PNG'"
      )
      .required(),
    imageData: string()
      .matches(
        /(data:image\/[^;]+;base64[^"]+)/g,
        "Ensure cover image is a valid 'JPEG or PNG'"
      )
      .required(),
  }),
  object({
    shape: mixed().oneOf(["SQUARE", "CIRCLE"]),
    x: number("'x' must be a number").required(),
    y: number("'y' must be a number").required(),
    height: number("'height' must be a number").required(),
    width: number("'width' must be a number").required(),
  }),
  object({
    hideUsername: boolean(),
    x: number("'x' must be a number"),
    y: number("'y' must be a number"),
    height: number("'height' must be a number"),
    width: number("'width' must be a number"),
  }),
];

export const getCurrentStepFields = (formData) => {
  return [
    {
      title: formData.title,
      subtitle: formData.subtitle,
      description: formData.description,
      url: formData.url,
      tags: formData.tags,
      visibility: formData.visibility,
      bannerData: formData.bannerData,
      imageData: formData.bannerData,
    },
    {
      shape: formData.imageAttribute.shape.toLocaleUpperCase(),
      x: formData.imageAttribute.x,
      y: formData.imageAttribute.y,
      height: formData.imageAttribute.height,
      width: formData.imageAttribute.width,
    },
    {
      hideUsername: formData.hideUsername,
      nameAttribute: {
        x: formData.nameAttribute.x,
        y: formData.nameAttribute.y,
        height: formData.nameAttribute.height,
        width: formData.nameAttribute.width,
      },
    },
  ];
};

export const validateForms = async (activeStep, data) => {
  try {
    const currentValidationSchema = validationSchemas[activeStep];
    await currentValidationSchema?.validate(data);
    return await currentValidationSchema?.isValid(data);
  } catch (error) {
    return error.message;
  }
};
